import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { numberFormat } from '@fiverr-private/localization';
import GetThumbnail from '../GetThumbnail';
import * as FilerrsSelectors from '../../selectors/filerrs';
import * as Translations from '../../providers/i18n';
import './style.scss';

export const FileReview = ({ commentsCount, fileName, thumbnail, previewType, i18n }) => {
    if (!commentsCount) { return null; }

    const formattedCommentsCount = numberFormat(commentsCount, {
        fallbackValue: commentsCount
    });

    return (
        <div className="file-review">
            <GetThumbnail previewType={previewType} thumbnail={thumbnail}/>

            <div className="main-review">
                <p className="comments-num">{i18n.t('attachments_preview.comments_summary_modal.new_comments', { count: formattedCommentsCount })}</p>
                <p className="file-name">{fileName}</p>
            </div>
        </div>
    );
};

FileReview.defaultProps = {
    fileName: '',
    thumbnail: '',
    commentsCount: 0
};

FileReview.propTypes = {
    fileName: PropTypes.string,
    thumbnail: PropTypes.string,
    commentsCount: PropTypes.number,
    previewType: PropTypes.string,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

const mapStateToProps = (state, { item }) => {
    const { id } = item.filerr;

    return {
        commentsCount: item.commentsCount,
        fileName: FilerrsSelectors.getFileNameById(state, id),
        thumbnail: FilerrsSelectors.getThumbUrlById(state, id),
        previewType: FilerrsSelectors.getPreviewTypeById(state, id)
    };
};

export default compose(
    Translations.connect,
    connect(mapStateToProps))(FileReview);
